import { getCities as getCitiesFromJoules } from '@/helper/joules';
import { useState } from 'react';

export interface CitiesByPostcodeResult {
  postcodes: { postcode: string; city: string }[];
}

export interface InitGetCitiesResult {
  getCities: (postcode: string) => void;
  loading: boolean;
  error: Error | undefined;
  data: CitiesByPostcodeResult | undefined;
}

export function initGetCitiesQuery(): InitGetCitiesResult {
  const [data, setData] = useState<CitiesByPostcodeResult | undefined>(undefined);

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  const getCities = async (postcode: string) => {
    setLoading(true);
    setError(undefined); // Fehler zurücksetzen, bevor eine neue Anfrage gesendet wird
    setData(undefined); // Daten zurücksetzen, bevor eine neue Anfrage gesendet wird

    try {
      const cities = await getCitiesFromJoules(postcode);
      setData({
        postcodes: (cities || []).map((city) => ({ city, postcode })),
      });
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  };

  return { getCities, loading, error, data };
}
